import React, { useContext, useState } from "react";
import {
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  Grid,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate, useLocation  } from "react-router-dom";
import axios from 'axios';
import { AuthContext } from "../context/AuthContext";
import { showSweetAlert } from "../components/SweetAlert";

const PricingPlans = () => {
  const [planType, setPlanType] = useState("monthly");
  const navigate = useNavigate();
  const location = useLocation();
  const { email, name } = location.state || {}; 
  const { setUserData } = useContext(AuthContext);
  const [loadingPlanId, setLoadingPlanId] = useState(null);

  console.log(email);
  console.log(name);

  const handlePlanTypeChange = (event, newPlanType) => {
    if (newPlanType) {
      setPlanType(newPlanType);
    }
  };

  const handleGetStarted = async(purchasePlan) => {
    // console.log(`Selected Plan: ${purchasePlan.planId}`);
    const token = localStorage.getItem('accessToken');
    const userId = localStorage.getItem('userId');

    const paidAt = new Date().toISOString();
    const planDuration = planType === "monthly" ? "30" : "365";
    const expiryAt = new Date(Date.now() + planDuration * 1000 * 60 * 60 * 24).toISOString(); // Add the duration in milliseconds to the current time
    const amount = parseFloat(purchasePlan.price.replace(/[^\d.-]/g, ""));
    const paymentType = purchasePlan.title;

    localStorage.setItem('paidAt', paidAt);
    localStorage.setItem('planDuration', planType);
    localStorage.setItem('expiryAt', expiryAt);
    localStorage.setItem('paymentType', paymentType);
    setLoadingPlanId(purchasePlan.planId);
    if (purchasePlan.title === "Basic") {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/${userId}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
      });
      if(response.data.account_status === 'signed_up'){
        showSweetAlert('Warning!', `You account is being set up. Please try login after later.`, 'warning');
        console.log('Warning');
        navigate('/');
        return;
      }
      else{
        navigate("/demo");
      }
      // navigate("/demo"); // Redirect to the home screen
    } else {
      // console.log(`Selected Plan: ${purchasePlan.title}`);
      try {
        const response =  await axios.post('https://ibkrapi.nodojicommodities.com/custom-apis/create-payment-link',
        {
          price_ids: [purchasePlan.planId],
          email: email,
        });

        if(response.status === 200){
          const paymentUrl = response.data.url;
          if (paymentUrl) {
            window.location.href = paymentUrl;  // Open in a new tab
          } else {
            console.error('No URL returned from the API.');
          }
        }
      }
      catch(error){
        console.error("Error fetching user data:", error);
      }finally {
        setLoadingPlanId(null); // Reset loading state after API call
      }
    }
  };

  const plans = [
    {
      title: "Basic",
      price: "Free",
      features: ["3 Customizable Pages", "100+ Indicators"],
      planId: planType === "monthly" ? "" : "",
    },
    {
      title: "Foundation",
      price: planType === "monthly" ? "$150 / per month" : "$1500 / per year",
      features: [
        "Connect Up to 3 Accounts",
        "3 Customizable Pages",
        "100+ Indicators",
        "In-Platform Alerts",
        "Client Communication",
        "Create Custom Reports Tailored",
      ],
      planId: planType === "monthly" ? "price_1QbkhHELiv4fymOQ35sDx9as" : "price_1QbkhUELiv4fymOQSGTgcQ06",
    },
    {
      title: "Professional",
      price: planType === "monthly" ? "$300 / per month" : "$3000 / per year",
      features: [
        "Connect Up to 10 Accounts",
        "10 Customizable Pages",
        "100+ Indicators",
        "Custom Indicators",
        "AI Assistant",
        "SMS / Email Alerts",
        "Priority Customer Service",
      ],
      planId: planType === "monthly" ? "price_1Qbki6ELiv4fymOQ6FNbZ722" : "price_1QbkiIELiv4fymOQYlpRDUF5",
    },
    {
      title: "Expert",
      price: planType === "monthly" ? "$500 / per month" : "$5000 / per year",
      features: [
        "Connect Unlimited Accounts",
        "Unlimited Customizable Pages",
        "100+ Indicators",
        "Custom Indicators",
        "AI Assistant",
        "SMS / Email Alerts",
        "Dedicated Customer",
        "Support Agent",
      ],
      planId: planType === "monthly" ? "price_1QbkktELiv4fymOQgYRjgAzq" : "price_1Qbkl8ELiv4fymOQUJAjjq7j",
    },
  ];

  return (
    <Box
      sx={{
        background: "linear-gradient(to bottom, #3a3a3a, #181818)",
        color: "white",
        py: 5,
      }}
    >
      <Container maxWidth="lg">
        <Card className="empty-card">
          <Typography variant="h3" align="center" sx={{ mb: 2 }}>
            Choose your right plan!
          </Typography>
          <Row>
            <Col lg={3}></Col>
            <Col lg={6}>
              <Typography variant="h6" align="center" sx={{ mb: 3 }}>
                Select from the best plans, ensuring a perfect match. Need more or
                less? Customize your subscription for a seamless fit!
              </Typography>
            </Col>
          </Row>

        </Card>
        {/* Toggle Button for Plan Type */}
        <Box className="d-flex justify-content-center">
          <Card className="empty-card" style={{ width: "fit-content", borderRadius: "0px !important" }}>
            <ToggleButtonGroup
              value={planType}
              exclusive
              onChange={handlePlanTypeChange}
              sx={{
                display: "flex",
                justifyContent: "center",
                mb: 4,
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                borderRadius: 2,
              }}
            >
              <ToggleButton
                value="monthly"
                sx={{
                  color: "white",
                  "&.Mui-selected": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
                }}
              >
                Monthly
              </ToggleButton>
              <ToggleButton
                value="annually"
                sx={{
                  color: "white",
                  "&.Mui-selected": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
                }}
              >
                Annually
              </ToggleButton>
            </ToggleButtonGroup>
          </Card>
        </Box>


        {/* Plan Cards */}
        <Grid container spacing={4}>
          {plans.map((plan, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
              className="payment-card"
                sx={{
                  height: "100%",
                  borderRadius: 2,
                  color: "white",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <CardContent sx={{paddingBottom: "0px"}}>
                  <Typography variant="h6" gutterBottom>
                    {plan.title}
                  </Typography>
                  <Typography
                    variant="h4"
                    gutterBottom
                    sx={{ fontWeight: "bold", paddingLeft: "15px" }}
                  >
                    <Box component="span">
                      {plan.price.split(" ")[0]}
                    </Box>
                    <Box component="span" sx={{ fontWeight: "normal" }} className="price-feature">
                      {` ${plan.price.split(" ").slice(1).join(" ")}`}
                    </Box>
                  </Typography>
                  <hr />
                  <ul style={{ padding: 0, paddingLeft: "15px", listStyle: "none" }}>
                    {plan.features.map((feature, i) => (
                      <li key={i} style={{ marginBottom: "8px" }} className="price-feature">
                        <img src={`${process.env.PUBLIC_URL}/images/grammerly.svg`} alt="user-img" /> {feature}
                      </li>
                    ))}
                  </ul>
                </CardContent>
                <Button
                  className="price-submit"
                  variant="contained"
                  sx={{
                    mt: 2,
                    mb: 2,
                    mx: "auto",
                    width: "80%",
                    backgroundColor: "#48494C",
                    color: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#5A5B5F",
                    },
                    "&.Mui-disabled": {
                      color: "#ffffff", // Ensure the text color remains white when disabled
                    },
                  }}
                  onClick={() => handleGetStarted(plan)}
                  disabled={loadingPlanId === plan.planId}
                >
                  {loadingPlanId === plan.planId ? "Getting Started..." : "Get Started"}
                </Button>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default PricingPlans;
